import { computable, iterable, mix, observable } from "@chorda/core";
import { ContentLayout, LevelLayout, Tab, Tabs } from "chorda-bulma";
import { Coerced, Custom } from "../utils";
export const ExamplePanel = (props) => {
    return mix({
        injections: {
            tabs: () => observable(props.tabs, (v) => v.name),
            title: () => observable(props.title),
            selected: (scope) => scope.router.route.params.element,
            components: (scope) => computable(() => {
                const components = scope.tabs.reduce((acc, tab) => {
                    acc[tab.name] = tab.name == scope.selected;
                    return acc;
                }, {});
                return components;
            })
        },
        css: 'example-panel',
        templates: {
            header: Custom({
                css: 'example-header',
                as: LevelLayout([{
                        title: Custom({
                            css: 'example-title',
                            as: ContentLayout([{
                                    tag: 'h4',
                                    reactions: {
                                        title: (v) => ({ text: v })
                                    }
                                }])
                            // templates: {
                            //     content: {
                            //         tag: 'h4',
                            //         reactions: {
                            //             title: (v) => ({text: v})
                            //         }
                            //     }
                            // }
                        })
                    }, {
                        tabs: Tabs({
                            tabs$: (scope) => iterable(scope.$context.tabs),
                            defaultTab: Coerced({
                                as: Tab({
                                    text$: (scope) => scope.tab.title,
                                    link$: (scope) => scope.tab.link,
                                    active$: (scope) => computable(() => {
                                        //                                    console.log('is tab active', scope.selected, scope.tab.name)
                                        return scope.selected == scope.tab.name;
                                    })
                                }),
                                injections: {
                                    tab: (scope) => scope.__it // _next(scope.tabs) //next(scope, 'tabs')
                                }
                            })
                        })
                    }])
            }),
            content: {
                css: 'example-content',
                components: false,
                reactions: {
                    tabs: (v) => {
                        const templates = v.reduce((acc, tab) => {
                            acc[tab.name] = tab.example;
                            return acc;
                        }, {});
                        return { templates };
                    },
                    components: (v) => {
                        return { components: v };
                    }
                }
            }
        }
    });
};
